import { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useDeepCompareEffect } from 'react-use';

import { loadBackOfficeEnterprises } from 'store/modules/backOfficeEnterprises/actions';
import { selectBackOfficeEnterprisesRequestParameters } from 'store/modules/routerUtils/selectors';

type Props = {
  isReady: boolean
};

function BackOfficeEnterprisesRequest({ isReady }: Props): null {
  const backOfficeEnterprisesRequestParameters = useSelector(
    selectBackOfficeEnterprisesRequestParameters
  );

  const dispatch = useDispatch();

  useDeepCompareEffect(() => {
    if (isReady) {
      dispatch(loadBackOfficeEnterprises());
    }
  }, [dispatch, backOfficeEnterprisesRequestParameters, isReady]);

  return null;
}

export default memo(BackOfficeEnterprisesRequest);
